import { render } from "./LoadingImgs.vue?vue&type=template&id=f25958c2&scoped=true"
import script from "./LoadingImgs.vue?vue&type=script&lang=js"
export * from "./LoadingImgs.vue?vue&type=script&lang=js"

import "./LoadingImgs.vue?vue&type=style&index=0&id=f25958c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f25958c2"]])

export default __exports__